const API_URL = {
	uri: 'https://api-buyanz.lensyun.com/api/v1',
	uri1: 'http://127.0.0.1:6001/api/v1',
	www: 'www.buyanz.com',
	cdn: 'https://nz.static.lensyun.com',
	gst: '125-152-112',
	bank: 'ANZ: 06-0229-0894524-01 Name: Unicross Business Development Limited',
	wechat: '微信转账: buyanz01 姓名: 林泳杏',
	alipay: '支付宝转账: yvonne@kiwipainting.co.nz 姓名: 张继良',
	title: '新易购',
	subtitle: '最值得信赖的海淘平台',
	title_en: 'BUYANZ',
	subtitle_en: '',
	payment: 'ANZ: 06-0229-0894524-01 Name: Unicross Business Development Limited',
	leto: false

}
export default API_URL
